(() => {
  'use strict'

  const getStoredTheme = () => localStorage.getItem('mytheme')
  const setStoredTheme = theme => localStorage.setItem('mytheme', theme)

  const getPreferredTheme = () => {
    const storedTheme = getStoredTheme()
    if (storedTheme) {
      return storedTheme
    }

    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  }

  const setTheme = theme => {
    if (theme === 'auto') {
      document.documentElement.setAttribute('data-bs-theme', (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'))
    } else {
      document.documentElement.setAttribute('data-bs-theme', theme)
    }
  }

  setTheme(getPreferredTheme())

  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    const storedTheme = getStoredTheme()
    if (storedTheme !== 'light' && storedTheme !== 'dark') {
      setTheme(getPreferredTheme())
    }
  })

  const setActiveTheme = theme => {

    document.querySelectorAll('[data-my-theme-value]').forEach(toggle => {
        if(theme == 'dark'){
            toggle.setAttribute('data-my-theme-value', 'light')
            toggle.classList.add('active')
            toggle.setAttribute('aria-pressed', 'true')
        }else{
            toggle.setAttribute('data-my-theme-value', 'dark')
            toggle.classList.remove('active')
            toggle.setAttribute('aria-pressed', 'false')
        }
    })
  }

  window.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('[data-my-theme-value]')
      .forEach(toggle => {
        toggle.addEventListener('click', () => {
          const theme = toggle.getAttribute('data-my-theme-value')
          setStoredTheme(theme)
          setTheme(theme)
          setActiveTheme(theme)
        })
      })
  })
})()